export enum FaxAnalyticsEvents {
  FileSelected = 'file_slctd',
  FileRemoved = 'file_removed',
  LinkCopied = 'link_copied',
  ConfirmationEmailAdded = 'conf_email_added',
  ConfirmationEmailRemoved = 'conf_email_removed',
  SendSuccess = 'send_success',
  SendFailure = 'send_failure',
  Selected = 'selected',
  NewFaxModalOpened = 'new_fax_modal_opened',
  QuickActionResend = 'quick_action_resend',
  QuickActionReply = 'quick_action_reply',
  // Fax PDF preview (PdfViewer / PdfToolbar). Load/download failures are the
  // failure side of the fax access-success signal (observability RFC).
  PreviewOpenedInTab = 'preview_opened_in_tab',
  PreviewLoadFailed = 'preview_load_failed',
  PreviewDownloaded = 'preview_downloaded',
  PreviewDownloadFailed = 'preview_download_failed',
  PreviewPrint = 'preview_print',
  PreviewPrintFallback = 'preview_print_fallback',
}
